import React from 'react';
import logo from '../../assets/img/icons/LogoGuardianNova-h.png';

const MenuLogo = () => {
  return (
    <div className="logo">
      <center>
        <img src={logo} alt="Guardian" width="155" />
      </center>
    </div>
  );
};

export default MenuLogo;
